import { useEffect, useMemo, useState } from 'react'
import { Button, ButtonGroup, Typography } from '@mui/material'
import { useTranslation } from 'react-i18next'
import { useSearchParams } from 'react-router-dom'
import BarcodeFailChecks from './BarcodeFailChecks'
import BarcodeFailChecksSummary from './BarcodeFailChecksSummary'

type TabName = 'occurrences' | 'summary'

const BarcodeFailChecksTabs = (): JSX.Element => {
  const { t } = useTranslation()
  const [selectedTab, setSelectedTab] = useState<TabName>('occurrences')
  const [searchParams, setSearchParams] = useSearchParams()

  useEffect(() => {
    const tab = searchParams.get('tab') as TabName | null
    if (tab === 'occurrences' || tab === 'summary') {
      setSelectedTab(tab)
    }
  }, [searchParams])

  const changeTab = (name: TabName): void => {
    setSelectedTab(name)
    setSearchParams({ tab: name })
  }

  const content = useMemo(() => {
    if (selectedTab === 'summary') return <BarcodeFailChecksSummary />
    return <BarcodeFailChecks />
  }, [selectedTab])

  return (
    <>
      <Typography variant="h5" fontWeight={600} component="h1" mb={2}>
        {t('navigation.barcodeFailChecks')}
      </Typography>
      <ButtonGroup sx={{ mb: 2 }} size="small" color="secondary">
        <Button
          variant={selectedTab === 'occurrences' ? 'contained' : 'outlined'}
          onClick={() => changeTab('occurrences')}
        >
          {t('barcode.occurrences', 'Occurrences')}
        </Button>
        <Button variant={selectedTab === 'summary' ? 'contained' : 'outlined'} onClick={() => changeTab('summary')}>
          {t('barcode.summary', 'Summary')}
        </Button>
      </ButtonGroup>
      {content}
    </>
  )
}

export default BarcodeFailChecksTabs
